import React, { useEffect, useRef, useState } from 'react';
import { BuilderProduct, actions as builderActions } from "@/store/builderSlice";
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
interface ProductThumbnailProps {
    product: BuilderProduct;
}


export default function ProductThumbnail(props: { product: BuilderProduct; changeSize?: boolean; }) {
    const { product, changeSize } = props;
    const dispatch = useDispatch();
    const imageRef = useRef<HTMLImageElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    // useEffect(() => {
    //     const containers = [
    //         'productDetailsMainContainer',
    //         'designDetailsMainContainer',
    //         'moreItemsMainContainer',
    //     ];

    //     containers.forEach((id) => {
    //         const element = document.getElementById(id);
    //         if (element) {
    //             element.style.visibility = isDragging ? 'hidden' : 'initial';
    //         }
    //     });
    // }, [isDragging]);
    const [{ opacity }, drag, preview] = useDrag(() => ({
        type: 'box',
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            opacity: monitor.isDragging() ? 1 : 1,
        }),
        item: (monitor) => {
            if (props.product.availability == "Available") {
                setIsDragging(true);
                dispatch(builderActions.updateDragSession({
                    dragSession: {
                        isActive: true,
                        productId: props.product.productId,
                    }
                }));
                return { ...props.product, imageRef: imageRef.current };
            }
        },
        end: () => {
            setIsDragging(false);
            dispatch(builderActions.updateDragSession({
                dragSession: {
                    isActive: false,
                    productId: null,
                }
            }));
        }
    }))

    const handleImageLoad = (event: any) => {
        const imgElement = getImageElement(10, 10);
        //preview(imgElement, { offsetX: imgElement.width / 2, offsetY: imgElement.height / 2 });
    };

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, [])

    const getImageElement = (width: number, height: number) => {
        const imgElement = new Image();
        imgElement.src = props.product.productImage;
        imgElement.width = width;
        imgElement.height = height;
        return imgElement;
    };

    return (
        <Box
            component={'div'}
            data-testid="product-thumbnail"
            draggable={false}
            ref={drag}
            style={{ cursor: 'grab' }}
        >
            <img
                src={props.product.productImage}
                style={{ width: '100%', height: changeSize ? '350px' : '180px', objectFit: 'contain' }}
                draggable={false}
                onLoad={handleImageLoad}
                ref={imageRef}
            />
        </ Box>
    );
}
